import React, { useEffect } from "react";

const AboutSection = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(
      ".fade_up, .fade_down, .zoom_in, .zoom_out, .fade_right, .fade_left, .flip_left, .flip_right, .flip_up, .flip_down"
    );
    hiddenElements.forEach((el) => observer.observe(el));

    return () => {
      hiddenElements.forEach((el) => observer.unobserve(el));
    };
  }, []);
  return (
    <>
      {/* <!-- ====================================== Section About ===================================== --> */}
      <section className="About-section jos" id="about">
        <div className="heading-container">
          <h2 className="section-heading-text about-me fade_up">About Me.</h2>
          <div className="line"></div>
        </div>
        <p className="section-sub-text about-sub-text">
          Hi, my name is <span>Tushar Kohli</span> I'm a data-driven problem solver who specializes in digital analytics. With <span>6.5 years</span> of experience and a strong foundation in <span>front-end development</span>, I don’t just track user behavior — I understand it. My technical background helps me move fast, adapt quickly, and build analytics solutions that truly support business growth and user experience.
        </p>
        <p className="section-sub-text about-sub-text">
        Over the years, I’ve worked with leading brands to implement and optimize analytics using <span>Adobe Analytics, Adobe Launch, GA4, Google Tag Manger, Quantum Metric, and OneTrust</span>. I’m passionate about turning complex data into clear insights, and I always stay hands-on — whether it’s setting up tracking, troubleshooting implementations, or fine-tuning reports to drive smarter decisions.
        </p>
        <p className="section-sub-text about-sub-text">
        My foundation in front-end development especially <span>Javascript & its frameworks</span> gives me a <span>unique edge in analytics</span> — allowing me to quickly understand site structures, troubleshoot technical issues, and <span>collaborate seamlessly with engineering teams</span>. It also helps me stay adaptable and pick up new tools and technologies faster, ensuring every solution I build is both <span>technically sound and business-focused.</span>
        </p>
      </section>
      {/* <!-- ====================================== Section About End ===================================== --> */}
    </>
  );
};
export default AboutSection;
